import { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, useIonToast } from '@ionic/react'
import { IonItem, IonLabel, IonRow, IonSpinner, IonText } from '@ionic/react'
import { refresh } from 'ionicons/icons'
import { Accountant } from '../../../API'
import { AccountantService } from '../../../components/services/AccountantService'
import { TbnResponse } from '../../../components/services/TbnResponse'
import { UserService } from '../../../components/services/UserService'
import ImageUpload from '../../../components/util/ImageUpload'
import { failure, success } from '../../../components/util/Toast'
import AdminContainer from '../AdminContainer'

interface OwnProps {}
interface AccountantEditProps extends OwnProps {}

const AccountantEdit: FC<AccountantEditProps> = () => {
  const { sub } = useParams<any>()
  const [user, setUser] = useState<any>()
  const [accountant, setAccountant] = useState<Accountant>()
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState(false)
  const [present] = useIonToast()

  const addOrEdit = async () => {
    setEditing(true)
    if (!!accountant) {
      const res: TbnResponse = await AccountantService.Instance.addOrEditAccountant(user?.id, accountant)
      if (res.data) success('Success updating accountant', present)
      else if (res.errorMessage) failure(res.errorMessage, present)
    }
    setEditing(false)
  }

  const loadUser = async (sub: string) => {
    setLoading(true)
    setUser(undefined)
    setAccountant(undefined)
    const res: TbnResponse | any = await UserService.Instance?.findBySub(sub)
    if (res.data) {
      setUser(res.data)
    } else if (res.errorMessage) {
      failure(res.errorMessage, present)
    }
    setLoading(false)
  }

  const load = async (userID: string) => {
    setLoading(true)
    const res: TbnResponse = await AccountantService.Instance.findAccountant(userID)
    if (!!res.data) {
      setAccountant(res.data)
    } else if (res.errorMessage) {
      failure(res.errorMessage, present)
      setAccountant({ userID } as Accountant)
    }
    setLoading(false)
  }

  const userDisplay = (user: any) => {
    return user?.email
  }

  const isFormInvalid = () => !accountant?.name

  useEffect(() => {
    if (!!accountant?.avatar) {
      addOrEdit()
    }
  }, [accountant?.avatar]) // eslint-disable-line

  useEffect(() => {
    if (!!sub) {
      loadUser(sub)
    }
  }, [sub]) // eslint-disable-line

  useEffect(() => {
    if (!!user?.id) {
      load(user.id)
    }
  }, [user?.id]) // eslint-disable-line

  return (
    <AdminContainer
      id='accountantEdit'
      title={userDisplay(user)}
      actionButtonsEnd={
        <IonButton onClick={() => load(user?.id)}>
          <IonIcon icon={refresh} slot='icon-only' />
        </IonButton>
      }
    >
      <IonGrid>
        <IonRow>
          <IonCol>
            {loading && (
              <div className='ion-text-center'>
                <IonSpinner />
              </div>
            )}
            {!loading && !user?.id && (
              <IonText>
                Accountant's user account doesn't exist, Accountant need to login and update her/his given name and
                surname first.
              </IonText>
            )}
          </IonCol>
        </IonRow>
        {!!user && !loading && (
          <>
            <IonRow>
              <IonCol>
                <IonItem>
                  <IonLabel className='required'>Name</IonLabel>
                  <IonInput
                    value={accountant?.name}
                    onIonChange={(e: any) => setAccountant({ ...accountant, name: e.detail.value } as Accountant)}
                    disabled={editing}
                  />
                </IonItem>
                <ImageUpload
                  defaultPath='images/accountant/avatar'
                  defaultImage={accountant?.avatar}
                  label='Avatar'
                  avatar={true}
                  onTbnChange={(avatar: string) => setAccountant({ ...accountant, avatar } as Accountant)}
                />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol className='ion-text-end'>
                <IonButton onClick={addOrEdit} disabled={editing || isFormInvalid()}>
                  Save
                </IonButton>
              </IonCol>
            </IonRow>
          </>
        )}
      </IonGrid>
    </AdminContainer>
  )
}

export default AccountantEdit
